import Vue from 'vue';
import {
  Floating,
  Message,
  Pagination,
  DatePicker,
  Input,
  Button,
  ButtonGroup,
  Dialog,
  Table,
  TableColumn,
  TimeSelect,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tree,
  Alert,
  Slider,
  Icon,
  Loading,
  Theme,
  Select,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Collapse,
  CollapseItem,
  Option,
  Radio,
  RadioGroup,
  RadioTag,
  NewAlert,
  RadioButton,
  Autocomplete,
  MessageBox,
  Progress,
  SearchBar,
} from '@didi/r-fusion-pc';
Vue.use(Floating);
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(Input);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(TimeSelect);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Select);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Option);
Vue.use(Autocomplete);
Vue.use(Loading);
Vue.use(Theme);
Vue.use(Dialog);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(RadioTag);
Vue.use(Progress);
Vue.use(SearchBar);

// Vue.prototype.$ELEMENT = { size: 'small' };
Vue.prototype.$loading = Loading.service;
Vue.prototype.$confirm = NewAlert.confirm;
Vue.prototype.$message = Message;

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;

import locale from '@didi/r-fusion-pc/lib/locale';
import I18nUtil from '@didi/i18n-util';
import { getBrand } from '@/utils/index';
const { getLanguage } = I18nUtil;
import '../common/style/r-fusion-pc-variables.scss';
import { rFusionPCLangList } from './langList';

locale.use(rFusionPCLangList[getLanguage().short]);

const THEME = (() => {
  return getBrand();
})();

if (THEME === '99') {
  Theme.use('99');
} else {
  Theme.use('didi');
}
